import type { TestGroupingGroup } from '@vedalib/editor/lib/elements'
import { FileUsageTypeEnum } from '@vedalib/editor/lib/files'
import { isEmptyRtValue } from '@vedalib/rich-text'
import { useContext } from 'use-context-selector'

import { getObjectFitDivMap } from 'components/Editor/EditorElements/utils/getObjectFitDivMap'
import { RichTextViewer } from 'components/form/RichText/RichTextViewer'
import { t } from 'services/Translation'
import { useUrlByUsage } from 'utils/files'

import TestGroupingContext from '../../TestGroupingContext'
import * as s from './PdfView.module.scss'

interface IPdfGroupCardProps {
  group: TestGroupingGroup
}

const PdfGroupCard = ({ group }: IPdfGroupCardProps) => {
  const { styles, font } = useContext(TestGroupingContext)
  const imageUrl = useUrlByUsage(group.target.image, FileUsageTypeEnum.image)
  const hasImage = !!group.target.image?.id
  const backgroundImage = hasImage ? `url(${imageUrl})` : undefined
  const hasLabel = group.target.label && !isEmptyRtValue(group.target.label)
  const showPlaceholder = !hasLabel && !hasImage

  return (
    <div
      aria-label={group.target.image?.accessibility}
      className={s.card}
      style={{
        ...styles.common,
        ...styles.group,
        backgroundImage,
        backgroundSize: getObjectFitDivMap(group.target.image?.objectFit),
      }}
    >
      <div
        className={s.mask}
        style={{
          backgroundColor: group.target.overlay || undefined,
          borderRadius: styles.common.borderRadius,
        }}
      />
      <div
        className={s.label}
        style={{
          padding: styles.indents.padding,
          justifyContent: styles.group.alignItems,
        }}
      >
        <div className={s.textInner} style={font?.base}>
          {showPlaceholder ? (
            t('elements.grouping.placeholder.group')
          ) : (
            <RichTextViewer styles={font} value={group.target.label} />
          )}
        </div>
      </div>
    </div>
  )
}

export default PdfGroupCard
